import ApiHelper from './index';

const fetchAnalyticsAlerts = (orgName, spinner = true) =>
  ApiHelper.get('telemetry/analytics-alert/', spinner, { org: orgName });

const createAnalyticsAlert = (payload, spinner = true) =>
  ApiHelper.post('telemetry/analytics-alert/', payload, spinner);

const updateAnalyticsAlert = (id, payload, spinner = true) =>
  ApiHelper.patch(`telemetry/analytics-alert/${id}/`, payload, spinner);

const deleteAnalyticsAlert = (id, spinner = true) =>
  ApiHelper.remove(`telemetry/analytics-alert/${id}/`, spinner);

const addRecipient = (configId, email, spinner = true) =>
  ApiHelper.post(
    `telemetry/analytics-alert/${configId}/recipients/`,
    { email },
    spinner
  );

const deleteRecipient = (recipientId, spinner = true) =>
  ApiHelper.remove(
    `telemetry/analytics-alert/recipients/${recipientId}/`,
    spinner
  );

// Fires the report immediately, independent of the cron schedule.
const sendAnalyticsAlertNow = (id, spinner = true) =>
  ApiHelper.post(`telemetry/analytics-alert/${id}/send/`, {}, spinner);

// Returns { blob, filename } — renders the PDF without emailing anyone.
const downloadAnalyticsAlertPreview = (id, spinner = true) =>
  ApiHelper.getFile(`telemetry/analytics-alert/${id}/preview/`, spinner);

export default {
  fetchAnalyticsAlerts,
  createAnalyticsAlert,
  updateAnalyticsAlert,
  deleteAnalyticsAlert,
  addRecipient,
  deleteRecipient,
  sendAnalyticsAlertNow,
  downloadAnalyticsAlertPreview,
};
